import { Role } from "../types/enums/Role";

export const GRADUATION_VALIDATION_MIN_PROGRESS = 90;
export const EVALUATION_EXTERNAL_URL = "https://membres.objectif-trading.fr/evaluation";
export const EVALUATION_MODE_ENABLED = false;

export const getNextTraderRole = (currentRole?: string | null): string | null => {
    if (currentRole === Role.Junior) return Role.Expert;
    if (currentRole === Role.Expert) return Role.Pro;
    if (currentRole === Role.Pro) return Role.Independant;
    if (currentRole === Role.Independant) return Role.Forme;
    return null;
};

export const getPreviousTraderRole = (
    currentRole?: string | null
): string | null => {
    if (currentRole === Role.Forme) return Role.Independant;
    if (currentRole === Role.Independant) return Role.Pro;
    if (currentRole === Role.Pro) return Role.Expert;
    if (currentRole === Role.Expert) return Role.Junior;
    return null;
};

export const canShowPromoteAction = (
    nextRoleName: string | null | undefined,
    progressPercent: number
) =>
    Boolean(nextRoleName) &&
    progressPercent >= GRADUATION_VALIDATION_MIN_PROGRESS;

export const canShowDemoteAction = (
    previousRoleName: string | null | undefined
) => Boolean(previousRoleName);

export const getPromoteButtonLabel = (nextRoleName: string | null | undefined) => {
    if (!nextRoleName) return "Valider";
    if (nextRoleName === Role.Forme) return "Valider la formation";
    return `Promouvoir → ${nextRoleName}`;
};

/** Formé seul : « Annuler validation » ; sinon « Rétrograder → … ». */
export const getDemoteButtonLabel = (
    previousRoleName: string | null | undefined,
    currentRoleName?: string | null
) => {
    if (currentRoleName === Role.Forme) return "Annuler validation";
    if (previousRoleName) return `Rétrograder → ${previousRoleName}`;
    return "Annuler promotion";
};

/** Ordre d'affichage / filtre admin (bas → haut). */
export const getTraderRoleSortRank = (roleName?: string | null): number => {
    switch (roleName) {
        case Role.Inscrit:
            return 0;
        case Role.Junior:
            return 1;
        case Role.Expert:
            return 2;
        case Role.Pro:
            return 3;
        case Role.Independant:
            return 4;
        case Role.Forme:
            return 5;
        default:
            return 99;
    }
};

export const isStaffRole = (roleName?: string | null) =>
    roleName === Role.Admin ||
    roleName === Role.SuperAdmin ||
    roleName === Role.Formateur;

export const isAdminRole = (roleName?: string | null) =>
    roleName === Role.Admin || roleName === Role.SuperAdmin;

export const isTraderProgressionRole = (roleName?: string | null) => {
    if (!roleName || isStaffRole(roleName) || roleName === Role.Inscrit) {
        return false;
    }
    return (
        [
            Role.Junior,
            Role.Expert,
            Role.Pro,
            Role.Independant,
            Role.Forme,
        ] as string[]
    ).includes(roleName);
};

/** Popup mensuelle statut financé : Expert et au-dessus uniquement. */
export const isFundingReminderEligibleRole = (
    roleName?: string | null
): boolean =>
    roleName === Role.Expert ||
    roleName === Role.Pro ||
    roleName === Role.Independant ||
    roleName === Role.Forme;

/** Onglet Progression : staff toujours ; membres seulement s’ils ont une promo. */
export const canAccessOwnProgression = (
    roleName?: string | null,
    promotionId?: string | null
): boolean => isStaffRole(roleName) || Boolean(promotionId);

export const getProgressionTitle = (roleName?: string | null) => {
    if (isTraderProgressionRole(roleName)) {
        return `Progression en tant que Trader ${roleName}`;
    }
    if (isStaffRole(roleName)) {
        return `Compte staff — ${roleName}`;
    }
    if (roleName) {
        return `Progression — ${roleName}`;
    }
    return "Progression";
};
